import {PerformanceTest} from './performance-test';
import {Utils} from '../../../../shared/utils/utils';
import {PerformanceAdviceMapper} from './performance-advice-mapper';
import {PerformanceRequestMapper} from './performance-request-mapper';

export class PerformanceTestMapper {

  public static map(data: any): PerformanceTest {
    const performanceTest: PerformanceTest = new PerformanceTest();

    performanceTest.id = data.id;
    performanceTest.score = data.score;
    performanceTest.testedUrl = data.testedUrl.replace(/(^\w+:|^)\/\//, '');
    performanceTest.grade = Utils.getPerformanceGrade(data.score);
    performanceTest.loadTime = data.browsertime && data.browsertime.statistics && data.browsertime.statistics.timings && data.browsertime.statistics.timings.fullyLoaded ? data.browsertime.statistics.timings.fullyLoaded.median : 0;
    performanceTest.pageSize = ( data.har ? data.har.transferSize : "" );
    performanceTest.advices = data.coach && data.coach.advice ? PerformanceAdviceMapper.parseAdvices(data.coach.advice) : [];
    performanceTest.testedAt = data.testedAt ? Utils.getDate(data.testedAt) : null;
    performanceTest.requests = data.har && data.browsertime && data.browsertime.browserScripts && data.browsertime.browserScripts[0] && data.browsertime.browserScripts[0].timings && (data.browsertime.browserScripts[0].timings.resourceTimings).length !== 0 ? PerformanceRequestMapper.mapRequests(data.har.assets, performanceTest.testedAt, data.browsertime.browserScripts[0].timings.resourceTimings, performanceTest.loadTime) : null;
    performanceTest.requestsCount = performanceTest.requests ? performanceTest.requests.length : 0;

    return performanceTest;
  }

}
